// extracted by mini-css-extract-plugin
export default {"onOffBtn":"OnOffButton_onOffBtn__kIaBp"};